<template>
<div>
  <login-header v-bind="headerInfo" @listenToChildEvent="showMsgFromChild"></login-header>
  <div class="guide" :style="{ height: screenHeight + 'px' }">
    <div class="guide__left" :style="{ height: screenHeight + 'px' }">
      <GuideBox :guideInfo="plusInfo"/>
    </div>
    <div class="guide__right" :style="{ height: screenHeight + 'px' }">
      <div class="triangle" :style="{ borderWidth: screenHeight + 500 + 'px' + ' 235px' + ' 0' + ' 0'}"></div>
      <GuideBox :guideInfo="brandInfo"/>
    </div>
  </div>
</div>
</template>
<script>
import qs from 'qs'
import GuideBox from '../guide-box'
import loginHeader from '../header'
const BRAND_INFO = {
  type: 'brand',
  title: '我是中大型连锁商家',
  intro: '面向中大型连锁商家，提供多场景的门店服务<br/>助力商家提升效率和顾客体验，实现数字化经营',
  img: 'https://img-shop.qmimg.cn/s1000184/images/2020/06/01/e94f5d68df4ad689.png'
}
const PLUS_INFO = {
  type: 'plus',
  title: '我是中小商家',
  intro: '面向中小商家，提供标准的<br/>门店运营服务，实现门店智慧经营',
  img: 'https://img-shop.qmimg.cn/s1000184/images/2020/06/01/6cf8073f99c57b88.png'
}
export default {
  data() {
    return {
      loading: true,
      screenHeight: document.documentElement.clientHeight - 76,
      headerInfo: {
        type: '选择店铺',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      plusInfo: PLUS_INFO,
      brandInfo: BRAND_INFO
    }
  },
  components: {
    loginHeader,
    GuideBox
  },
  watch: {
    screenHeight (val) {
      if (!this.timer) {
        this.screenHeight = val
        this.timer = true
        setTimeout(() => {
          this.timer = false
        }, 400)
      }
    }
  },
  created() {
    document.title = localStorage.getItem('title')
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
  },
  mounted() {
    this.headerInfo.userName = localStorage.getItem('mobile') || ''
    this.get_bodyHeight()
  },
  methods: {
    get_bodyHeight () {
      window.onresize = () => {
        return (() => {
          this.$nextTick(() => {
            window.screenHeight = document.documentElement.clientHeight - 76
            this.screenHeight = window.screenHeight
          })
        })()
      }
    },
    showMsgFromChild(data, loadingData) {
      this.loading = loadingData
      setTimeout(() => {
        this.loading = false
        this.headerInfo.userDisplayFlag = data
        localStorage.setItem('mobile', '')
        localStorage.setItem('mytoken', '')
        this.$router.push({ path: `/login.html` })
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.guide {
  width: 100%;
  display: flex;
  position: relative;
  &__left {
    flex: 1;
    background: #fede2c url('https://img-shop.qmimg.cn/s1001063/images/2020/05/28/36edebbdbbf60062.png') top center no-repeat;
    background-size: 40% auto;
    position: relative;
    overflow: hidden;
    margin-left: -235px;
    transition: all 1s;
    z-index: 2;
    .white_box {
      position: absolute;
      right: 45px;
      z-index: 1;
      @media screen and (max-width: 1024px){
       right: 0px;
      }
      @media screen and (min-width: 1152px) {
        right: 0px;
      }
      @media screen and (min-width: 1200px) {
        right: 30px;
      }
    }
    @media screen and (max-width: 1024px){
      margin-left: -470px;
    }
  }
  &__right {
    flex: 1;
    position: relative;
    overflow: hidden;
    z-index: 0;
    background: #3f9aff url('https://img-shop.qmimg.cn/s1000184/images/2020/05/31/c307df4ac80f4bc4.png') 100px bottom no-repeat;
    background-size: 100% auto;
    transition: all 1s;
    margin-left: -80px;
    .triangle {
      width: 0px;
      height: 0px;
      border-color: #fede2c transparent;
      border-style: solid;
    }
    .white_box {
      position: absolute;
      left: 275px;
    }
    @media screen and (max-width: 1280px){
      margin-left: -36px;
    }
    @media screen and (min-width: 1400px){
      margin-left: -35px;
    }
    @media screen and (min-width: 1440px) {
      margin-left: -65px;
    }
  }
}
</style>